/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { PagedResponseOfPlayerListEntryFromJSON, PlayerCreationRequestToJSON, PlayerOptionsResponseFromJSON, PlayerResponseFromJSON, PlayerUpdateRequestToJSON, } from '../models';
/**
 *
 */
var PlayerRestControllerApi = /** @class */ (function (_super) {
    __extends(PlayerRestControllerApi, _super);
    function PlayerRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new player <p> \'Permission#CREATE_PLAYER\' is required to access to this endpoint
     * Create a new player <p> \'Permission#CREATE_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.createPlayerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.playerCreationRequest === null || requestParameters.playerCreationRequest === undefined) {
                            throw new runtime.RequiredError('playerCreationRequest', 'Required parameter requestParameters.playerCreationRequest was null or undefined when calling createPlayer.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: PlayerCreationRequestToJSON(requestParameters.playerCreationRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PlayerResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new player <p> \'Permission#CREATE_PLAYER\' is required to access to this endpoint
     * Create a new player <p> \'Permission#CREATE_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.createPlayer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPlayerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete player <p> \'Permission#DELETE_PLAYER\' is required to access to this endpoint
     * Delete player <p> \'Permission#DELETE_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.deletePlayerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.playerId === null || requestParameters.playerId === undefined) {
                            throw new runtime.RequiredError('playerId', 'Required parameter requestParameters.playerId was null or undefined when calling deletePlayer.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players/{playerId}".replace("{".concat("playerId", "}"), encodeURIComponent(String(requestParameters.playerId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete player <p> \'Permission#DELETE_PLAYER\' is required to access to this endpoint
     * Delete player <p> \'Permission#DELETE_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.deletePlayer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deletePlayerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get player details <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     * Get player details <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.getPlayerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.playerId === null || requestParameters.playerId === undefined) {
                            throw new runtime.RequiredError('playerId', 'Required parameter requestParameters.playerId was null or undefined when calling getPlayer.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players/{playerId}".replace("{".concat("playerId", "}"), encodeURIComponent(String(requestParameters.playerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PlayerResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get player details <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     * Get player details <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.getPlayer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPlayerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get player options <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     * Get player options <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.getPlayerOptionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.network !== undefined) {
                            queryParameters['network'] = requestParameters.network;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players/options",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PlayerOptionsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get player options <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     * Get player options <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.getPlayerOptions = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPlayerOptionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get players public key (rsa-ssh public key)
     * Get players public key (rsa-ssh public key)
     */
    PlayerRestControllerApi.prototype.getPlayersPublicKeyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.playerId === null || requestParameters.playerId === undefined) {
                            throw new runtime.RequiredError('playerId', 'Required parameter requestParameters.playerId was null or undefined when calling getPlayersPublicKey.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players/{playerId}/public-key".replace("{".concat("playerId", "}"), encodeURIComponent(String(requestParameters.playerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get players public key (rsa-ssh public key)
     * Get players public key (rsa-ssh public key)
     */
    PlayerRestControllerApi.prototype.getPlayersPublicKey = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPlayersPublicKeyRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List players using pagination <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     * List players using pagination <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.listPlayersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.location !== undefined) {
                            queryParameters['location'] = requestParameters.location;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfPlayerListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List players using pagination <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     * List players using pagination <p> \'Permission#READ_PLAYER\' is required to access to this endpoint
     */
    PlayerRestControllerApi.prototype.listPlayers = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listPlayersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch player (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_PLAYER\' is required to access to this endpoint. A player may update only itself.
     * Patch player (partial update).
     */
    PlayerRestControllerApi.prototype.patchPlayerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.playerId === null || requestParameters.playerId === undefined) {
                            throw new runtime.RequiredError('playerId', 'Required parameter requestParameters.playerId was null or undefined when calling patchPlayer.');
                        }
                        if (requestParameters.playerUpdateRequest === null || requestParameters.playerUpdateRequest === undefined) {
                            throw new runtime.RequiredError('playerUpdateRequest', 'Required parameter requestParameters.playerUpdateRequest was null or undefined when calling patchPlayer.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players/{playerId}".replace("{".concat("playerId", "}"), encodeURIComponent(String(requestParameters.playerId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: PlayerUpdateRequestToJSON(requestParameters.playerUpdateRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PlayerResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch player (partial update). The patch request do not unset any value by setting null on a certain field. To unset any value use (PUT) update method. <p> \'Permission#UPDATE_PLAYER\' is required to access to this endpoint. A player may update only itself.
     * Patch player (partial update).
     */
    PlayerRestControllerApi.prototype.patchPlayer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchPlayerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update player <p> \'Permission#UPDATE_PLAYER\' is required to access to this endpoint. A player may update only itself.
     * Update player <p> \'Permission#UPDATE_PLAYER\' is required to access to this endpoint.
     */
    PlayerRestControllerApi.prototype.updatePlayerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.playerId === null || requestParameters.playerId === undefined) {
                            throw new runtime.RequiredError('playerId', 'Required parameter requestParameters.playerId was null or undefined when calling updatePlayer.');
                        }
                        if (requestParameters.playerUpdateRequest === null || requestParameters.playerUpdateRequest === undefined) {
                            throw new runtime.RequiredError('playerUpdateRequest', 'Required parameter requestParameters.playerUpdateRequest was null or undefined when calling updatePlayer.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/players/{playerId}".replace("{".concat("playerId", "}"), encodeURIComponent(String(requestParameters.playerId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: PlayerUpdateRequestToJSON(requestParameters.playerUpdateRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PlayerResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update player <p> \'Permission#UPDATE_PLAYER\' is required to access to this endpoint. A player may update only itself.
     * Update player <p> \'Permission#UPDATE_PLAYER\' is required to access to this endpoint.
     */
    PlayerRestControllerApi.prototype.updatePlayer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePlayerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PlayerRestControllerApi;
}(runtime.BaseAPI));
export { PlayerRestControllerApi };
